import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloForfait,cleanAloForfait } from '@/models/alo/AloForfait'

export default {
  getAllForfait(): AxiosPromise<AlrContainer<Array<AloForfait>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Forfait`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloForfait>>
      }]
    })
  },
  getForfait(id:number):AxiosPromise<AlrContainer<AloForfait>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Forfait/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloForfait>
      }]
    })
  },
  saveForfait(forfait:AloForfait):AxiosPromise<AlrContainer<AloForfait>> {
    cleanAloForfait(forfait)
    if(forfait.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Forfait/${forfait.id}`, 
        method: 'PUT',
        data: forfait,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloForfait>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Forfait`, 
        method: 'POST',
        data: forfait,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloForfait>
        }]
      })    
    }
  },
  deleteForfait(id:number):AxiosPromise<AlrContainer<AloForfait>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Forfait/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloForfait>
      }]
    })
  }
}